import { optimisticRemoveComponentsByLid } from 'api'
import { delFetcher } from 'api/swr'
import {
  jobMatchesLayer,
  useCptUploadStore,
} from 'Editor/BottomPanel/BatchUpload/uploadQueue'

export const softDeleteLayer = async (tid, id) => {
  await delFetcher('/layers', { arg: { id, body: { tid } } })
  optimisticRemoveComponentsByLid(tid, id)
  const { jobs, removeJob } = useCptUploadStore.getState()
  jobs
    .filter((job) => job.tid === tid && jobMatchesLayer(job, id))
    .forEach((job) => removeJob(job.id))
}
